<div class="users-filter">
  <h5 class="filter-title">{{'CALL_HISTORY.USER' | translate}}</h5>
  <mat-form-field>
    <mat-label>{{label}}</mat-label>
    <mat-select #usersSelector
                (selectionChange)="addFilter('agentIds', $event.value)"
                multiple
                [formControl]="selectedUsersForm"
    >
      <mat-select-trigger *ngIf="selectedUsersForm.value?.length">
        {{displayLabel | translate}}
        <div *ngIf="selectedUsersForm.value?.length > 1" class="more-items-label">
          (+{{selectedUsersForm.value.length - 1}})
        </div>
      </mat-select-trigger>
      <mat-checkbox
        class="phone-numbers-filter-option select-all"
        [(ngModel)]="allUsersSelected"
        [(indeterminate)]="indeterminate"
        (change)="toggleAllUsersSelect()">
        {{'SELECT_ALL' | translate }}
      </mat-checkbox>
      <mat-option *ngFor="let user of users"
                  [value]="user.id"
                  class="users-filter-option"
                  [class.disabled]="user.state === 'INACTIVE'"
      >
        {{getUserName(user) | translate}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
